
export class PlumberDetailsRwi {
  plumberName: string;
  plumberPhoneNumber: string;
  plumberEmailAddress: string;
  plumberLicenseNumber: string;
  errorMessage: string;

  constructor() {
  this.errorMessage = null;
  }

  toUpperCase() {
    if (this.plumberName) {
      this.plumberName = this.plumberName.toUpperCase();
    }

    if (this.plumberPhoneNumber) {
      this.plumberPhoneNumber = this.plumberPhoneNumber.toUpperCase();
    }

    if (this.plumberEmailAddress) {
      this.plumberEmailAddress = this.plumberEmailAddress.toUpperCase();
    }

    if (this.plumberLicenseNumber) {
      this.plumberLicenseNumber = this.plumberLicenseNumber.toUpperCase();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/plumber-details-rwi.ts